export default __webpack_public_path__ + "static/media/ENTP-2.85094893.png";